import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);      // { email, name } when logged in
    const [checking, setChecking] = useState(true);

    const check = useCallback(async () => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            setAdmin(null);
            setChecking(false);
            return;
        }
        try {
            const { data } = await api.get("/admin/me");
            setAdmin(data);
        } catch {
            localStorage.removeItem("admin_token");
            setAdmin(null);
        } finally {
            setChecking(false);
        }
    }, []);

    useEffect(() => {
        check();
    }, [check]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/admin/login", { email, password });
            localStorage.setItem("admin_token", data.token);
            setAdmin(data.admin);
            return { ok: true };
        } catch (err) {
            return { ok: false, error: formatApiError(err) };
        }
    };

    const logout = () => {
        localStorage.removeItem("admin_token");
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, checking, login, logout, refresh: check }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
